/**
 * La nota informativa: spiega come leggere una vista o cosa fa un comando
 * (la scala di un grafico, cosa conta, cosa succede salvando). Testo piccolo,
 * corsivo e grigio, così non si confonde con i dati né con gli stati vuoti.
 * Le regole sono in `docs/navigazione-e-viste.md`, §1.12.
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function Nota({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p className={cn('text-xs text-pretty text-muted-foreground italic', className)}>{children}</p>
  );
}
